import React from 'react'
import { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { Menu, MenuItem, IconButton } from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import { FlexContainer } from '../../layouts'
import { Button } from '../../components'
import { triggerNotification } from '../../actions/notifications'
import { copyToClipboard } from '../../services/common'
import { resolvePublishedURL } from '../../services/pack'

interface ILocationActionsComponent {
  shortURI?: string
  publishedURI?: string
  title: string
  published: boolean
  publish: boolean
  packId: string
  editionId: string
  name: string
  dispatch: Dispatch
}

const LocationActionsComponent = ({
  shortURI,
  publishedURI,
  title,
  published,
  publish,
  packId,
  editionId,
  name,
  dispatch,
}: ILocationActionsComponent) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (e): void => {
    setAnchorEl(e.currentTarget)
  }
  const copy = (url: string): void => {
    copyToClipboard(url, () => {
      dispatch(triggerNotification('Copied'))
    })
  }
  const handleClose = (): void => {
    setAnchorEl(null)
  }
  const handleError = (message: string): void => {
    dispatch(triggerNotification(message))
  }

  return published ? (
    <FlexContainer>
      <Button
        id="auto-copy-link-and-title-button"
        type="button"
        variant="contained"
        color="primary"
        onClick={() => copy(`${title} ${shortURI}`)}
      >
        Copy link and title
      </Button>
      <IconButton
        id="auto-copy-link-and-title-menu"
        type="button"
        onClick={handleClick}
      >
        <MoreVert color="primary" />
      </IconButton>
      <Menu
        id="editon-copy-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        {shortURI && (
          <MenuItem onClick={() => copy(shortURI)}>Copy link</MenuItem>
        )}
        {publishedURI && (
          <MenuItem onClick={() => copy(publishedURI)}>
            Copy publish link
          </MenuItem>
        )}
        <MenuItem>
          <a href={`mailto:?subject=${title}&body=${title} ${shortURI}`}>
            Email link
          </a>
        </MenuItem>
        <MenuItem>
          <a href={publishedURI} target="_blank" rel="noopener noreferrer">
            Open in browser
          </a>
        </MenuItem>
      </Menu>
    </FlexContainer>
  ) : publish ? (
    <Button
      id="auto-copy-link-and-title-button"
      type="button"
      variant="contained"
      color="primary"
      onClick={() => {
        resolvePublishedURL({ packId, editionId, name }, copy, handleError)
      }}
    >
      Copy publish link
    </Button>
  ) : null
}

export const LocationActions = connect()(LocationActionsComponent)
